/*--------------
V 1.0.0 - Criado por Larner Diogo

DESCIÇÃO:
Roteador geral da Aplicação


COMPONENTS
***********************************************************/
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardService } from './globals/guard';

/**********************************************************
PAGES
***********************************************************/
import { NoAuthorizationComponent } from './no-authorization/index';
import { AuthorizationComponent } from './authorization/index';

export const routes: Routes = [

  //ROTA PROTEGIDA
  {
    path: '',
    component: AuthorizationComponent,
    canActivate: [GuardService],
    children: [
      {
        path: '',
        loadChildren: './authorization/module#Module'
      },
    ]
  },

  //ROTAS GERAIS
  {
    path: 'no-auth',
    component: NoAuthorizationComponent,
    children: [
      {
        path: '',
        loadChildren: './no-authorization/module#Module'
      },
    ]
  },

  //404
  { path: '**', pathMatch: 'full', redirectTo: 'no-auth/404' },

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts